import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { DCInput } from './dynamic.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'dynamic-empty',
    template: `<dialog-window [title]="title" (close)="close()" >
                <div [innerHtml]="_content"> </div>
              </dialog-window>`
})
/**
 * Используется для динамической вставки компоненты из HTML строки.
 */
export class DynamicEmptyComponent implements OnInit, OnDestroy, DCInput {
    /**
     * Заголовок диалогового окна
     */
    title = "Внимание!";
    /**
     * Не использовать это значение, оно является приватным. Содержимое контейнера в виде HTML строки
     */
    _content:SafeHtml = "";
    /**
     * Подписчик для удаления компоненты
     */
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    constructor(private _sanitazer:DomSanitizer) { }

    ngOnInit() { }
    ngOnDestroy(){
        this.destroyEmitter.complete();
    }
    /**
     * Содержимое контейнера в виде HTML строки
     */
    get content(){
        return this._content.toString();
    }
    set content(val:string){
        this._content = this._sanitazer.bypassSecurityTrustHtml(val);
    }
    /**
     * Закрывает диалоговое окно
     */
    close(){
        this.destroyEmitter.emit(null);
    }
}